/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — SME Performance dashboard — RTK Query slice. Real data:
   revenue/shipments from growthos_revenue_daily, deals from GrowthOsDeal, targets
   from GrowthOsSmeTarget.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get } from '../common/constants'

const SME = apiConstants.GROWTHOS_ADMIN_SME

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosSmeApiSlice = createApi({
  reducerPath: 'growthosSmeApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['Sme'],
  endpoints: (b) => ({
    getSmeDashboard: b.query({
      queryFn: ({ period, from, to }) => run(get(SME, { period, from, to })),
      providesTags: ['Sme'],
    }),
  }),
})

export const { useGetSmeDashboardQuery } = growthosSmeApiSlice
